import { DestroyRef, inject, Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, map, tap } from "rxjs/operators";

const SEPARATOR = " > ";
declare let ga: Function;

@Injectable({
	providedIn: "root",
})
export class TitleService {
	private router: Router = inject(Router);
	private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
	private titleService: Title = inject(Title);
	private destroyRef: DestroyRef = inject(DestroyRef);
	static ucFirst(text: string) {
		if (!text) {
			return text;
		}
		return text.charAt(0).toUpperCase() + text.slice(1);
	}

	init() {
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				map(() => {
					let route = this.activatedRoute;
					while (route.firstChild) {
						route = route.firstChild;
					}
					return route;
				}),
				filter((route) => route.outlet === "primary"),
				map((route) => route.snapshot),
				map((snapshot) => {
					if (snapshot.data.title) {
						if (snapshot.paramMap.get("id") !== null) {
							return (
								snapshot.data.title +
								SEPARATOR +
								snapshot.paramMap.get("id")
							);
						}
						return snapshot.data.title;
					} else {
						// If not, we do a little magic on the url to create an approximation
						return this.router.url.split("/").reduce((acc, frag) => {
							if (acc && frag) {
								acc += SEPARATOR;
							}
							return acc + TitleService.ucFirst(frag);
						});
					}
				}),
				takeUntilDestroyed(this.destroyRef),
				tap((pathString) => {
					const [, existingTitle] = this.titleService.getTitle().split("|");
					this.titleService.setTitle(
						`${pathString}${existingTitle ? " |" + existingTitle : ""}`,
					);
					ga("set", "page", pathString);
					ga("send", "pageview");
				}),
			)
			.subscribe();
	}
}
